import React from 'react';
import {useLoaderData, useLocation} from '@remix-run/react';

//components
import {Link} from 'components/Link';

//domains
import {findNestedLevel, findParents, gidExists} from 'domains/collections';
import {loader} from '~/routes/($lang)/collections/$collectionHandle';
/** 主頁 / 所有品牌 / <brand>. `name` for a brand's own collection; the
 * vendor page reads it from pf_v_brand. */
export default function BrandBreadcrumb({name}: {name?: string}) {
  const {search} = useLocation();
  const params = new URLSearchParams(search);
  const requestedVendor = name ?? params.get('pf_v_brand');
  const {translation} = useLoaderData<typeof loader>();

  return (
    <div className="relative z-10 w-full bg-white">
      <div className="lg:px-0">
        <nav className="text-sm md:text-md flex flex-wrap items-center lg:mb-[34px]">
          <Link
            to="/"
            className="transition-colors duration-200 ease-out hover:text-hk-orange uppercase"
          >
            {translation.home ?? 'Home'}
          </Link>
          <span className="mx-2 inline-block font-light">/</span>
          <Link
            to="/pages/brands"
            className="transition-colors duration-200 ease-out hover:text-hk-orange uppercase"
          >
            {translation?.all_brands ?? 'All Brands'}
          </Link>
          <span className="mx-2 inline-block font-light">/</span>
          <span className="font-light uppercase">{requestedVendor}</span>
        </nav>
      </div>
      <div className="lg:col-span-6"></div>
    </div>
  );
}
